import { useCallback, useEffect, useState } from 'react';

export function SettingsPage() {
  const [isDark, setIsDark] = useState(() =>
    document.documentElement.classList.contains('dark'),
  );

  useEffect(() => {
    document.documentElement.classList.toggle('dark', isDark);
    localStorage.setItem('theme', isDark ? 'dark' : 'light');
  }, [isDark]);

  const toggleTheme = useCallback(() => {
    setIsDark((prev) => !prev);
  }, []);

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-(--color-text-primary) text-2xl font-bold">
          Settings
        </h1>
        <p className="text-(--color-text-secondary) mt-1 text-sm">
          Manage your application preferences
        </p>
      </div>

      <div className="border-(--color-border) bg-(--color-bg-primary) rounded-xl border p-6 shadow-sm">
        <h2 className="text-(--color-text-primary) text-lg font-semibold">
          Appearance
        </h2>
        <p className="text-(--color-text-secondary) mt-1 text-sm">
          Customize the look and feel of the dashboard
        </p>

        <div className="mt-6 flex items-center justify-between">
          <div>
            <p className="text-(--color-text-primary) text-sm font-medium">
              Dark Mode
            </p>
            <p className="text-(--color-text-secondary) text-xs">
              Toggle between light and dark theme
            </p>
          </div>
          <button
            onClick={toggleTheme}
            role="switch"
            aria-checked={isDark}
            className={`relative inline-flex h-6 w-11 items-center rounded-full transition-colors ${
              isDark ? 'bg-(--color-accent)' : 'bg-gray-300'
            }`}
          >
            <span
              className={`inline-block h-4 w-4 transform rounded-full bg-white transition-transform ${
                isDark ? 'translate-x-6' : 'translate-x-1'
              }`}
            />
          </button>
        </div>
      </div>
    </div>
  );
}
